import _ from "lodash";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import API from "lib/api/API2";
import { rootClasses } from "views/Pages/Finding/styles";
import { compileParams } from "views/Components/ServerTable";

const defaults = [
  { label: "All", value: 1 },
  { label: "Operational", value: 10 },
  { label: "Risk", value: 15 },
  { label: "Suspect", value: 20 },
  { label: "Threat", value: 30 },
];

const getStatusControl = (controls) => {
  return Object.values(controls).find((c) => c.field === "status");
};

const getTypeControl = (controls) => {
  return Object.values(controls).find((c) => c.field === "type");
};

const FindingQuickFilters = ({ controlInterface, controls, orgId }) => {
  const [labels, setLabels] = useState([...defaults]);

  // Fetch counts for the quick filter buttons asynchronously
  const fetchQuickFilterCounts = async () => {
    const params = [];
    for (const control of Object.values(controls)) {
      if (control.field === "type") continue;
      if (control.field === "status" && control.value === 0) continue;
      params.push(control);
    }
    const payload = {
      ...compileParams(params),
      outputFields: "type",
      count: "grouped_count",
      status: 0,
    };
    const api = new API();
    const response = await api.get("finding", payload, []);
    const data = response?.data || [];
    const newLabels = _.cloneDeep(defaults);
    let total = 0;
    for (const qf of newLabels) {
      let present = false;
      for (const item of data) {
        if (qf.value === item.type) {
          qf.label = `${qf.label} (${item.count})`;
          total += item.count;
          present = true;
        }
      }
      if (!present) {
        qf.label = `${qf.label} (0)`;
      }
    }
    newLabels[0].label = `All (${total})`;
    setLabels(newLabels);
  };

  useEffect(() => {
    fetchQuickFilterCounts();
  }, [controls, orgId]);

  const handleChangeSelected = (event, newValue) => {
    const existingType = getTypeControl(controls);
    const existingStatus = getStatusControl(controls);

    // Selecting an already selected quick filter should toggle it off
    if (
      existingType?.value === newValue ||
      (existingStatus && !existingType && newValue === 1)
    ) {
      controlInterface.remove(existingType?.uuid);
      controlInterface.remove(existingStatus?.uuid);
    } else {
      if (newValue && newValue !== 1) {
        controlInterface.addOrUpdate({
          ...existingType,
          field: "type",
          operator: "eq",
          value: newValue,
        });
      } else {
        controlInterface.remove(existingType?.uuid);
      }
      controlInterface.addOrUpdate({
        ...existingStatus,
        field: "status",
        operator: "eq",
        value: 0,
      });
    }
  };

  return (
    <div className={rootClasses.quickFilterContainer}>
      <span className={rootClasses.quickFilterLabel}>Open Findings</span>
      <ToggleButtonGroup
        exclusive
        value={"Quick filters"}
        onChange={handleChangeSelected}
        aria-label="Quick filters for findings table"
      >
        {labels.map(({ label, value }, index) => (
          <ToggleButton
            key={`${label}-${index}`}
            datacy={`index${index}QuickFilterButton`}
            value={value}
            aria-label={`Apply ${label} quick filter`}
            className={rootClasses.quickFilterButton}
            selected={
              getStatusControl(controls)?.value === 0 &&
              (getTypeControl(controls)?.value === value ||
                (!getTypeControl(controls) && value === 1))
            }
          >
            {label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </div>
  );
};

FindingQuickFilters.propTypes = {
  controlInterface: PropTypes.object.isRequired,
  controls: PropTypes.object.isRequired,
};

export default FindingQuickFilters;
